export const dockMessagesVi = {
    "dock.watchlist": "Danh mục",
    "dock.alerts": "Cảnh báo",
    "dock.dataWindow": "Cửa sổ dữ liệu",
    "dock.objectTree": "Cây đối tượng",
    "dock.tape": "Tape",
    "dock.orderTicket": "Đặt lệnh",
    "dock.advisory": "Tư vấn",
    "dock.upgrade": "Nâng cấp Pro để mở Dock",
    "dock.indicators": "Chỉ báo",
    "dock.emptyPanel": "Chưa có nội dung",
    "dock.tradingDisabled": "Paper trading đang tắt — bật ở thanh giao dịch nhanh",
    "dock.requiresDrawings": "Mở bảng vẽ để quản lý objects",
    "dock.requiresTape": "Cần dữ liệu tape",
    "dock.requiresAdvisory": "Chưa có kết quả phân tích",
    "dock.requiresPaperTrading": "Bật Paper Trading để đặt lệnh",
    "dock.pin": "Ghim Dock",
    "dock.unpin": "Bỏ ghim",
    "dock.toggleRail": "Bật/tắt thanh Dock",
    "dock.colLast": "Giá",
    "dock.colChange": "+/-",
    "dock.colChangePct": "%",
    "dock.footerRuler": "Thước đo",
    "dock.footerLockAll": "Khóa tất cả",
    "dock.footerHideAll": "Ẩn tất cả",
    "dock.footerTrash": "Xóa tất cả",
    "dock.footerCollapse": "Thu gọn",
};
